import type { CMSLinkFields } from '@dobrozem/cms';
import type { LinkProps } from 'next/link';
import Link from 'next/link';
import type { AnchorHTMLAttributes } from 'react';
type Props = {
  className?: string;
  link: CMSLinkFields;
} & Partial<AnchorHTMLAttributes<HTMLAnchorElement> & LinkProps>;
const resolveLinkProps = ({
  doc,
  inNewTab,
  type,
  url
}: Omit<CMSLinkFields, 'label'>) => {
  const resolveHref = () => {
    if (type === 'link') return url || '';
    if (!doc?.value || typeof doc?.value === 'string') return '/';
    const {
      value: {
        slug
      }
    } = doc;
    return `${slug === 'home' ? '/' : `/${slug}`}`;
  };
  return {
    href: resolveHref(),
    ...(inNewTab && {
      target: '_blank'
    })
  };
};
export const CMSLink = ({
  children,
  className,
  link,
  ...nextLinkProps
}: Props) => {
  const {
    label,
    ...fieldsToResolve
  } = link;
  return <Link {...nextLinkProps} className={className} {...resolveLinkProps(fieldsToResolve)} data-sentry-element="Link" data-sentry-component="CMSLink" data-sentry-source-file="CMSLink.tsx">
      {children ?? label}
    </Link>;
};